module.exports = __webpack_public_path__ + "img/xt5@2x.463e3762.png";